import { BrowserRouter, Routes, Route } from "react-router-dom";

import Header from "../components/Header/Header";
import Footer from "../components/Footer/Footer";

import HomePage from "../pages/HomePage/HomePage";
import ArtworkDetails from "../pages/ArtworkDetails/ArtworkDetails";

export default function AppRoutes() {
  return (
    <BrowserRouter>
      <Header />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/artwork/:id" element={<ArtworkDetails />} />
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}
